<p-toast position="bottom-right" key="br" />
<div class="flex flex-col h-screen w-screen">
    @if (authService.isLoading()) {
        <app-loading />
    } @else if (authService.isAuthenticated()) {
        <app-topbar></app-topbar>
        <div class="flex-1 overflow-auto">
                <router-outlet></router-outlet>
        </div>
    } @else {
        <app-loading />
    }
</div>

